module.exports = __webpack_public_path__ + "img/ep-sapin.2e24eebf.png";